import ExpansionPanel from '@material-ui/core/ExpansionPanel'
import ExpandMoreIcon from '@material-ui/icons/ExpandMore'
import ExpansionPanelDetails from '@material-ui/core/ExpansionPanelDetails'
import ExpansionPanelSummary from '@material-ui/core/ExpansionPanelSummary'
import ExpandablePanelStyle from '../../styles/ExpandablePanelStyle'
import React from 'react'

const ExpandablePanel = props => (
  <ExpandablePanelStyle multiRow={props.multiRow}>
    <ExpansionPanel
      defaultExpanded
      className={props.multiRow ? 'multi expansionPanel' : 'expansionPanel'}
    >
      <ExpansionPanelSummary
        className={
          props.multiRow
            ? 'ExpansionPanelSummary shortened'
            : 'ExpansionPanelSummary'
        }
        expandIcon={<ExpandMoreIcon color="primary" />}
      >
        <div className="title">
          <p
            className={
              props.multiRow
                ? 'high-emphasis-subtitle-1'
                : 'medium-emphasis-overline'
            }
          >
            {props.title}
          </p>
        </div>
      </ExpansionPanelSummary>
      <ExpansionPanelDetails
        className={
          props.withoutBackground ? 'details withoutBackground' : 'details'
        }
      >
        {props.children}
      </ExpansionPanelDetails>
    </ExpansionPanel>
  </ExpandablePanelStyle>
)

export default ExpandablePanel
